
$(document).ready(function () {

  // Header account-popup
  $(".login_popup").click(function () {
    $(".customer-account").removeClass("hidden");
    $("#shopify-section-account-popup ").show();
    $(".ctm-login-modal-bg").addClass("active");
    $(".customer-account").addClass("login-left");
    $(".login_popup.header__icon").addClass("active");
    $("body").addClass("overflow-hidden ctm_login_popup");
  });

  $(".ctm-login-modal-bg").click(function () {
    $(this).removeClass("active");
    $(".customer-account").addClass("hidden");
    $(".customer-account").removeClass("login-left");
    $(".login_popup.header__icon").removeClass("active");
    $("body").removeClass("overflow-hidden ctm_login_popup");
    $("#shopify-section-account-popup ").hide();
  });

  $("#login-none").click(function () {
    $(".login-cta").addClass("d-none");
    $(".ctm_login_nav .nav-link ").addClass("d-none");
    $(".reset-password").removeClass("d-none");
  });
  $("#recover-cancel").click(function () {
    $(".login-cta").removeClass("d-none");
    $(".ctm_login_nav .nav-link ").removeClass("d-none");
    $(".reset-password").addClass("d-none");
  });

  $("#regi_forgot_pass").click(function () {
    $(".forgot-block-area").addClass("d-none");
    $(".reset-password").removeClass("d-none");
  });
  $("#regi-recover-cancel").click(function () {
    $(".reset-password").addClass("d-none");
    $(".forgot-block-area").removeClass("d-none");
  });

  // popup tabbing
  $(".tab-heading ul li a").click(function () {
    var tab_idd = $(this).attr("data-tab");
    var tab_img = $(this).attr("data-img");

    $(".reset-password").addClass("d-none");
    $(".login-cta").removeClass("d-none");
    $(".forgot-block-area").removeClass("d-none");

    $(".tab-heading ul li a").removeClass("current");
    $(".account-tab.tab-pane").removeClass("current");

    $(this).addClass("current");
    $("#" + tab_idd).addClass("current");
    $("#" + tab_img).addClass("current");
  });

  // Header sticky
  $(window).scroll(function () {
    if ($(this).scrollTop() > 40) {
      $(".ctm_header_wrapper").addClass("menufixed");
      $("body").addClass("header-fixed");
      $("body").addClass("cart-top");
    } else {
      $(".ctm_header_wrapper").removeClass("menufixed");
      $("body").removeClass("header-fixed");
      $("body").removeClass("cart-top");
    }
  });

  $(".sidebarIconToggle").click(function () {
    $(this).toggleClass("sidebarclose");
    $(".sidebar").toggle();
    $(".sidebar").toggleClass("sidebaranimat");
    $("body").toggleClass("bodybarfixed");

  });
  // announcement bar slider Hide
  $(".ctm_close_icon ").click(function (e) {
    $("#annoucement_bar").hide();
    $('body').addClass("announcement-cartdrawer announcement-account_popup ")
  });
  $(".header__search .icon-search").click(function (e) {
    $('body').addClass("model_search_bar")
  });


  // mobile sub-menu hide show
  $('.menu-drawer__menu .ctm_click').on('click', function () {

    if ($(this).children('.drop-box-ctm').hasClass('submenu-open-ctm')) {
      $(this).children('.drop-box-ctm').removeClass('submenu-open-ctm');
      setTimeout(function () {
        $(this).children('.drop-box-ctm').removeAttr('open');
      }, 1000);
    } else {
      $('.menu-drawer__menu .ctm_click .drop-box-ctm').removeClass('submenu-open-ctm');
      $('.menu-drawer__menu .ctm_click .drop-box-ctm').removeAttr('open');
      $(this).children('.drop-box-ctm').addClass('submenu-open-ctm');
      $(this).children('.drop-box-ctm').attr('open');
    }
  });

  var swiper = new Swiper('.ctm_feature_coll_slider', {
    loop: false,
    slidesPerView: 3.8,
    spaceBetween: 32,
    speed: 1000,
    centeredSlides: false,
    centeredSlidesBounds: false,
    disableOnInteraction: false,
    mousewheel: {
   // releaseOnEdges: true,
      forceToAxis: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      hide: false,
      draggable: true,
    },
    breakpoints: {
      1440: {
        slidesPerView: 3.8,
        spaceBetween: 32,
      },
      1280: {
        slidesPerView: 3.4,
        spaceBetween: 28,
      },
      1024: {
        slidesPerView: 2.4,
        spaceBetween: 24,
      },
      0: {
        slidesPerView: 2.2,
        spaceBetween: 16,
      },
    },
  });


  
// HOME Ingredient CARD
  var swiper = new Swiper('.ctm_ingedientcard', {
    loop: false,
    slidesPerView: 3.3,
    spaceBetween: 90,
    speed: 1000,
    centeredSlides: false,
    centeredSlidesBounds: false,
    disableOnInteraction: false,
    mousewheel: {
     forceToAxis: true,
    },  
    navigation: {
      nextEl: ".ingred_next",
      prevEl: ".ingred_prev",
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      hide: false,
      draggable: true,
    },
    breakpoints: {
      1440: {
        slidesPerView: 3.26,
        spaceBetween: 90,
      },
      1280: {
        slidesPerView: 3.4,
        spaceBetween: 50,
      },
      1024: {
        slidesPerView: 2.4,
        spaceBetween: 35,
      },
      768: {
        slidesPerView: 2.4,
        spaceBetween: 32,
      },
      575: {
        slidesPerView: 1.5,
        spaceBetween: 32,
      },
      414: {
        slidesPerView: 1.2,
        spaceBetween: 32,
      },
      0: {
        slidesPerView: 1,
        spaceBetween: 32,
      },
    },
  });

  // PDP TESTIMONIAL SLIDER
  var mySwiper = new Swiper(".ctm_pdp_testimonial", {
    spaceBetween: 1,
    slidesPerView: 5.5,
    spaceBetween: 56,
    loop: true,
    roundLengths: true,
    centeredSlides: true,
    centeredSlidesBounds: true,
    speed: 1000,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
    navigation: {
      nextEl: ".ctm_pdpaero_next",
      prevEl: ".ctm_pdpaero_prev"
    },
    pagination: {
      el: ".ctm_pdpdots",
      clickable: true,
    },
    breakpoints: {
      1440: {
        slidesPerView: 3.8,
        spaceBetween: 56,
      },
      1280: {
        slidesPerView: 3.4,
        spaceBetween: 56,
      },
      1024: {
        slidesPerView: 2.4,
        spaceBetween: 56,
      },
      768: {
        slidesPerView: 2.2,
        spaceBetween: 56,
      },
      576: {
        slidesPerView: 1,
        spaceBetween: 32,
      },
      414: {
        slidesPerView: 1,
        spaceBetween: 32,
        roundLengths: false,
        centeredSlides: false,
        centeredSlidesBounds: false,
      },
      0: {
        slidesPerView: 1,
        spaceBetween: 32,
        roundLengths: false,
        centeredSlides: false,
        centeredSlidesBounds: false,
      },
    },
  });

  //footer menu js
  $(".footer-block__headings").click(function () {
    var targetFooterBlock = $(this).closest(".footer-block");
    var targetDetailsContent = targetFooterBlock.find("ul.footer-block__details-content");
    $(".footer-block").not(targetFooterBlock).removeClass("show");
    $("ul.footer-block__details-content").not(targetDetailsContent).removeClass("show");
    targetFooterBlock.toggleClass("show");
    targetDetailsContent.toggleClass("show");
  });
  // For collection mobile Dropdown
  $(".ctm_collection_title h5").click(function () {
    var targetFooterBlock = $(this).closest(".ctm_collection_sidebar");
    var targetDetailsContent = targetFooterBlock.find("ul.list-menu");
    $(".ctm_collection_title").not(targetFooterBlock).removeClass("show");
    $("ul.list-menu").not(targetDetailsContent).removeClass("show");
    targetFooterBlock.toggleClass("show");
    targetDetailsContent.toggleClass("show");
  });

  // Marquee Slider
  $(function () {
    const text = $(".footer_slider .marquee-text");
    const block = $(".footer_slider .block");
    const clone = text;

    const anim = () => {
      $(clone).clone().appendTo($(block));
      $(".footer_slider .block").animate(
        {
          left: "-100%"
        },
        10000,
        "linear",
        function () {
          $(".footer_slider  .marquee-text").first().remove();
          $(block).css("left", "0");
          anim();
        }
      );
    };

    const blockList = $(".footer_slider  .block-list");
    const list = $(".footer_slider  .marquee-list");
    const listWidth = list.width() + parseInt($(blockList).css("gap"));
    $(list).clone().appendTo($(blockList));
    const animList = () => {
      $(list).clone().appendTo($(blockList));
      $(blockList).animate(
        {
          left: -listWidth
        },
        12000,
        "linear",
        function () {
          $(".footer_slider .list").first().remove();
          $(blockList).css("left", "0");
          animList();
        }
      );
    };
    anim();
    animList();
  });
  
  // // Free gift text slider
  $(function () {
    const text = $(".gwp_offer-text .marquee-text");
    const block = $(".gwp_offer-text .block");
    const clone = text;

    const anim = () => {
      $(clone).clone().appendTo($(block));
      $(".gwp_offer-text .block").animate(
        {
          left: "-100%"
        },
        22000,
        "linear",
        function () {
          $(".gwp_offer-text  .marquee-text").first().remove();
          $(block).css("left", "0");
          anim();
        }
      );
    };

    const blockList = $(".gwp_offer-text  .block-list");
    const list = $(".gwp_offer-text  .marquee-list");
    const listWidth = list.width() + parseInt($(blockList).css("gap"));
    $(list).clone().appendTo($(blockList));
    const animList = () => {
      $(list).clone().appendTo($(blockList));
      $(blockList).animate(
        {
          left: -listWidth
        },
        22000,
        "linear",
        function () {
          $(".gwp_offer-text .list").first().remove();
          $(blockList).css("left", "0");
          animList();
        }
      );
    };
    anim();
    animList();
  });
  

  // FAQ Accordian
  let questions = document.querySelectorAll(".faq_question");

  questions.forEach((question) => {
      let icon = question.querySelector(".icon-shape");
  
      question.addEventListener("click", (event) => {
          const active = document.querySelector(".faq_question.active");
          const activeIcon = document.querySelector(".icon-shape.active");
  
          if (active && active !== question) {
              active.classList.toggle("active");
              activeIcon.classList.toggle("active");
              active.nextElementSibling.style.maxHeight = 0;
          }
  
          question.classList.toggle("active");
          icon.classList.toggle("active");
  
          const answer = question.nextElementSibling;
  
          if (question.classList.contains("active")) {
              answer.style.maxHeight = answer.scrollHeight + "px";
          } else {
              answer.style.maxHeight = 0;
          }
      });
  
      // Check if the question has the "open" class and add the "active" class accordingly
      if (question.classList.contains("open")) {
          question.classList.add("active");
          icon.classList.add("active");
          const answer = question.nextElementSibling;
          answer.style.maxHeight = answer.scrollHeight + "px";
      }
  });

  // FAQ SIDEBAR STICKY

  $('.ctm_multifaqsidebar_link a[href^="#"]').on('click', function (e) {
    e.preventDefault();

    var target = this.hash;
    var $target = $(target);

    // Get the height of the header
    var headerHeight = $('.ctm_header_wrapper').height();

    // Subtract the header height from the target offset
    var adjustedScrollTop = $target.offset().top - headerHeight;

    // Animate scrollTop
    $('html, body').stop().animate({
      'scrollTop': adjustedScrollTop
    }, 1000, 'swing', function () {

      // window.location.hash = target;
    });
  });

  // Recycle Guid Page product Grid Slider
  var quoteSwiper = new Swiper('.ctm_recyclegrid_contentslider', {
    direction: "vertical",
    effect: "slide",
    loop: false, // Not recommended to enable!!!
    allowTouchMove: false,
    grabCursor: true,
  });

  var $Speed = 1000;
  var imageSwiper = new Swiper('.ctm_recyclegrid_imageslider', {
    mousewheel: true,
    speed: $Speed,
    loop: false, // Not recommended to enable!!!
    longSwipesRatio: 0.01,
    followFinger: false,
    grabCursor: true,
    watchSlidesProgress: true,
    parallax: true,
    lazy: {
      loadPrevNext: true,
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      hide: false,
      draggable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      1440: {
        slidesPerView: 1,
      },
      1280: {
        slidesPerView: 1,
      },
      1024: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 32,
        parallax: false,
        watchSlidesProgress: false,
        longSwipesRatio: 0,
        mousewheel: {
          //releaseOnEdges: true,
          forceToAxis: true,
        },  
      },
      575: {
        slidesPerView: 1,
        spaceBetween: 32,
        parallax: false,
        watchSlidesProgress: false,
        longSwipesRatio: 0,
        mousewheel: {
          //releaseOnEdges: true,
          forceToAxis: true,
        },  
      },
      414: {
        slidesPerView: 1,
        spaceBetween: 32,
        parallax: false,
        watchSlidesProgress: false,
        longSwipesRatio: 0,
        mousewheel: {
          //releaseOnEdges: true,
          forceToAxis: true,
        },  
      },
      0: {
        slidesPerView: 1,
        spaceBetween: 32,
        parallax: false,
        watchSlidesProgress: false,
        longSwipesRatio: 0,
        mousewheel: {
          //releaseOnEdges: true,
          forceToAxis: true,
        },  
      },
    },
  });
  imageSwiper.controller.control = quoteSwiper;
  quoteSwiper.controller.control = imageSwiper;




  tabControl();

  var resizeTimer;
  $(window).on('resize', function(e) {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      tabControl();
    }, 250);
  });

  function tabControl() {
    var tabs = $('.tabbed-content').find('.tabs');
    if(tabs.is(':visible')) {
      tabs.find('a').on('click', function(event) {
        event.preventDefault();
        var target = $(this).attr('href'),
            tabs = $(this).parents('.tabs'),
            buttons = tabs.find('a'),
            item = tabs.parents('.tabbed-content').find('.item');
        buttons.removeClass('active');
        item.removeClass('active');
        $(this).addClass('active');
        $(target).addClass('active');
      });
    } 
    else {
      $('.item').on('click', function() {
        var container = $(this).parents('.tabbed-content'),
            currId = $(this).attr('id'),
            items = container.find('.item');
        container.find('.tabs a').removeClass('active');
        items.removeClass('active');
        $(this).addClass('active');
        container.find('.tabs a[href$="#'+ currId +'"]').addClass('active');
      });
    } 
  }

   // Fancybox Ingredient
  $('[data-fancybox="gallery"]').fancybox({
    buttons: ['slideShow', 'thumbs', 'zoom', 'fullScreen', 'share', 'close'],
    loop: false,
    protect: false,
    toolbar: false,
    smallBtn: true,
    touch: true,
    modal: false,
    clickSlide: "close",
    infobar: false,
    arrows: true,
    nextClick: true,
    baseClass: "ctm_ingredient_fancybox",
    slideClass: "ctm_ingredient_fancyboxinner",
    btnTpl: {
      arrowLeft:
        '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="28" viewBox="0 0 22 28" fill="none">' +
        '<path d="M15.4283 -0.000488856L0.457784 13.9995L15.4283 27.9995L22 27.9995L7.03083 13.9995L22 -0.000488281L15.4283 -0.000488856Z" fill="#333F48"/>' +
        '<path d="M15.4283 -0.000488856L0.457784 13.9995L15.4283 27.9995L22 27.9995L7.03083 13.9995L22 -0.000488281L15.4283 -0.000488856Z" fill="black" fill-opacity="0.2"/>' +
        '<path d="M15.4283 -0.000488856L0.457784 13.9995L15.4283 27.9995L22 27.9995L7.03083 13.9995L22 -0.000488281L15.4283 -0.000488856Z" fill="black" fill-opacity="0.2"/>' +
        '<path d="M15.4283 -0.000488856L0.457784 13.9995L15.4283 27.9995L22 27.9995L7.03083 13.9995L22 -0.000488281L15.4283 -0.000488856Z" fill="black" fill-opacity="0.2"/>' +
        '</svg>' +
        '</button>',
  
      arrowRight:
        '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
       
        '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="28" viewBox="0 0 22 28" fill="none">' +
        '<path d="M6.57171 27.9995L21.5422 13.9995L6.57171 -0.000488281L0 -0.000488281L14.9692 13.9995L0 27.9995H6.57171Z" fill="#333F48"/>' +
        '<path d="M6.57171 27.9995L21.5422 13.9995L6.57171 -0.000488281L0 -0.000488281L14.9692 13.9995L0 27.9995H6.57171Z" fill="black" fill-opacity="0.2"/>' +
        '<path d="M6.57171 27.9995L21.5422 13.9995L6.57171 -0.000488281L0 -0.000488281L14.9692 13.9995L0 27.9995H6.57171Z" fill="black" fill-opacity="0.2"/>' +
        '<path d="M6.57171 27.9995L21.5422 13.9995L6.57171 -0.000488281L0 -0.000488281L14.9692 13.9995L0 27.9995H6.57171Z" fill="black" fill-opacity="0.2"/>' +
        '</svg>' +
        '</button>'
    },
    afterLoad: function (instance, current) {
      var popupId = current.opts.$orig.data('popup-id');
      var popupContent = $('[data-popup-id="' + popupId + '"]');
      popupContent.find('.tooltip_ingredient_image, .ingred_popup_title, .ingred_popup_content').show();
    },
  });

  // Brand / "As Seen On" logo banner — mobile-only horizontal slider (task 1.4)
  // Markup is wrapped in .md:hidden, so the swiper element only exists on <768px.
  if (typeof Swiper !== 'undefined' && document.querySelector('.ctm-brand-swiper')) {
    new Swiper('.ctm-brand-swiper', {
      slidesPerView: 2.5,
      spaceBetween: 24,
      loop: true,
      grabCursor: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
    });
  }

});


// FOR ACCORDIAN TOOLTIP

document.addEventListener('DOMContentLoaded', function () {
  const tooltipCtas = document.querySelectorAll('.tooltip-cta');
  const tooltips = document.querySelectorAll('.tooltip');

  tooltipCtas.forEach(function (cta) {
    cta.addEventListener('click', function () {
      const targetId = cta.getAttribute('data-tooltip-target');
      const targetTooltip = document.getElementById(targetId);

      if (targetTooltip) {
        if (window.innerWidth <= 767) {
          // If screen width is 767px or less, toggle 'active' class for accordion effect
          targetTooltip.classList.toggle('active-accordion');
        } else {
          // If screen width is greater than 767px, close other tooltips and toggle 'active' class
          tooltips.forEach(function (tooltip) {
            if (tooltip !== targetTooltip) {
              tooltip.classList.remove('active', 'active-accordion');
            }
          });
          targetTooltip.classList.toggle('active');
        }
      }
      
      // Toggle the class instead of always adding
      cta.classList.toggle('tooltip_cta_active');
    });
  });

  document.addEventListener('click', function (event) {
    const isClickInsideTooltip = tooltips.forEach((tooltip)=> {
      return tooltip.contains(event.target);
    });

    if (!isClickInsideTooltip && window.innerWidth > 767) {
      tooltips.forEach(function (tooltip) {
        tooltip.classList.remove('active');
      });
    }
  });

  const tooltipCloseButtons = document.querySelectorAll('.tooltip-close');

  tooltipCloseButtons.forEach(function (closeButton) {
    closeButton.addEventListener('click', function (event) {
      const tooltip = closeButton.closest('.tooltip');

      if (tooltip) {
        tooltip.classList.remove('active', 'active-accordion');
      }
    });
  });

  //  HOME zoom in zoom out effect
  document.addEventListener("wheel", function(e) {
    const section = document.querySelector('.ctm_animat_block');
    const img1 = document.querySelector(".ctm_imgover1");
    const img2 = document.querySelector(".ctm_imgover2");
    const ZOOM_SPEED = 0.1;
    let zoom = 1.1; // Default zoom level

    if (window.scrollY + window.innerHeight > section.offsetTop) {
        // Zoom effect
        if (e.deltaY > 0) {
            // Scrolling down
            zoom += ZOOM_SPEED;
        } else {
            // Scrolling up
            zoom -= ZOOM_SPEED;
        }
        zoom = Math.max(1, Math.min(zoom, 1.1));
        // Apply zoom effect to images
        img1.style.transform = `scale(${zoom})`;
        img2.style.transform = `scale(${zoom})`;
        // Opacity effect
        if (e.deltaY > 0) {
            // Scrolling down
            img1.classList.add('opacity-0');
            img2.classList.remove('opacity-0');
        } else {
            // Scrolling up
            img1.classList.remove('opacity-0');
            img2.classList.add('opacity-0');
        }
    }
  });
 // Scroll To Footer JS
 window.addEventListener("load", function() {
  if (window.location.hash === "#stay_in_touch") {
    setTimeout(function() {
      document.getElementById("stay_in_touch").scrollIntoView({
        behavior: "smooth"
      });
    }, 100);
  }
});

// Scalp page scroll

$('a[data-position]').click(function(event) {
  var position = $(this).data('position');
  var targetDiv = $('#' + position);
  
  if (targetDiv.length) {
    $('html, body').stop().animate({
      scrollTop: targetDiv.offset().top - 60
    }, 100, 'swing');
  }
});

var swiperContainer = document.querySelector(".hero-slider");
if($(".hero-slider .swiper-slide").length > 0){ 
var numberOfSlides = swiperContainer.querySelectorAll(".swiper-slide").length;

var swiperConfig = {
  slidesPerView: 1,
  loop: numberOfSlides > 1, // Loop only if there's more than one slide
  speed: 800,
  draggable: true,
  centeredSlides: true,
  autoplay: enableAutoplay ? {
    delay: 6000,
    disableOnInteraction: false,
  }: false,
  navigation: {
    nextEl: ".home-swiper-button-next",
    prevEl: ".home-swiper-button-prev",
  },
  pagination: {
    el: ".hero-pagination",
    clickable: true,
  },
};

if (numberOfSlides > 1) {
  swiperConfig.autoplay = enableAutoplay ? {
    delay: 6000,
    disableOnInteraction: false,
  }: false;
} else {
  swiperConfig.autoplay = false; // Disable autoplay if there's only one slide
}

}
var swiper = new Swiper(".hero-slider", swiperConfig);

});

//pdp
let currentSlide = 0;
const slides = document.querySelectorAll('.new-slide');

function moveSlide(direction, event) {
  event.preventDefault(); // Prevents the default action of the button
  slides[currentSlide].classList.remove('active');
  currentSlide = (currentSlide + direction + slides.length) % slides.length;
    slides[currentSlide].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  slides[currentSlide].classList.add('active');
}
// subscribe(PUB_SUB_EVENTS.cartUpdate, async function (e) {
//   // Single GWP product variant
//   const gwpVariantId = '44883048595743'; // Variant ID of the GWP

//   const fetchCart = async () => {
//     try {
//       const response = await fetch('/cart.js', {
//         headers: { 'Cache-Control': 'no-cache', 'Pragma': 'no-cache' }
//       });
//       return await response.json();
//     } catch (error) {
//       console.error('Error fetching cart:', error);
//       return null;
//     }
//   };

//   const updateCartItems = async (updates) => {
//     try {
//       const response = await fetch('/cart/update.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ updates }),
//       });
//       return await response.json();
//     } catch (error) {
//       console.error('Error updating cart items:', error);
//     }
//   };

//   const handleCartUpdate = async () => {
//     const currentCart = await fetchCart();
//     if (!currentCart) return;

//     const totalPrice = currentCart.total_price / 100; // Convert from cents to dollars
//     const currentCartItems = currentCart.items;
//     const updates = {};

//     const existingGWPItem = currentCartItems.find(
//       item => item.variant_id.toString() === gwpVariantId
//     );

//     if (totalPrice >= 60) {
//       // Add the GWP if not already in the cart
//       if (!existingGWPItem) {
//         updates[gwpVariantId] = 1; // Add GWP with quantity 1
//       } else if (existingGWPItem.quantity > 1) {
//         // Correct the quantity to 1 if it exceeds 1
//         updates[existingGWPItem.key] = 1;
//       }
//     } else {
//       // Remove the GWP if the total price is below $60
//       if (existingGWPItem) {
//         updates[existingGWPItem.key] = 0; // Remove GWP
//       }
//     }

//     // Apply updates if any changes are needed
//     if (Object.keys(updates).length > 0) {
//       await updateCartItems(updates);
//       publish(PUB_SUB_EVENTS.cartUpdate, { source: 'free-gift-handler' });
//     }
//   };

//   try {
//     await handleCartUpdate();
//   } catch (error) {
//     console.error('Error in cart update handler:', error);
//   }
// });




